export default __webpack_public_path__ + "static/similarity-dont-bc24bed22f54aba3f2c9d852bd0270f8daab2bdafa385c4933c1c4e732eef6c8.png";